import axios from 'axios';
import $ from 'jquery';
import { getCookie } from "../utils/cookie";

export function trackData(data, submitId) {
  const utmb = getCookie('c__utmb')
  const utma = getCookie('c__utma')
  const tokenPath = 'https://host.convertlab.com/formdata/get/' + submitId
  const submitPath = 'https://host.convertlab.com/form/' + submitId
  let submitData = {}

  return axios.get(tokenPath).then(
    response => {
      if (response.status === 200) {
        const cltoken = response.data.token
        submitData.utma = utma
        submitData.utmb = utmb
        submitData.cltoken = cltoken

        submitData = {
          ...submitData,
          ...data
        }

        // console.log(submitData, data, '提交数据')
        $.post(submitPath, submitData).then(response => {
          // console.log(response)
        }).catch( err => { console.log(err) })
      }
    }
  ).catch(
    response => {
      console.log("请求失败")
    },
  );
}
